export const HOME_VIEW = {
  name: 'Dashboard',
  path: '/',
};

export const LOGIN_VIEW = {
  name: 'Login',
  path: '/auth/login',
};

export const ABOUT_VIEW = {
  name: 'About',
  path: '/about',
};

export const PAGE_NOT_FOUND = {
  name: 'PageNotFound',
  path: '/:pathMatch(.*)*',
};
